import $ from 'jquery';

class Price {
  constructor() {
    this.$select = $('.js-top-priceSelect');
    this.$selectType = $('#workshop-type');
    this.$selectPeople = $('#workshop-people');
    this.$selectCount = $('#workshop-count');
    this.$textType = $('#text-type');
    this.$textPeople = $('#text-people');
    this.$textCount = $('#text-count');
    this.$priceTotal = $('#price-total');
    this.$priceTotalNote = $('#price-total-note');
    this.$note = $('#workshop-note');
    this.$overlay = $('.js-top-priceCalcOverlay');
    if (this.$select.length > 0) {
      this.addEvent();
    }
  }

  addEvent() {
    this.$select.change(() => {
      const type = this.$selectType.val();
      const count = Number(this.$selectCount.val());
      const people = Number(this.$selectPeople.val());
      if( type != "" && people != "" && count) {
        var valueTotal = 0;
        var valueNote = 0;
        if(type === 'real') {
          this.$note.html('上記に加え、右記料金が発生します…著作権使用料、講師の移動にかかる交通費<br>参加人数やレッスンの回数が増えると、1名あたりの価格がお得になります。また朝日新聞社の「認知症フレンドリー講座」と合わせてお申込みいただきますとセット割引で更にお得になります。');
        } else {
          this.$note.html('上記に加え、右記料金が発生します…著作権使用料<br>参加人数やレッスンの回数が増えると、1名あたりの価格がお得になります。また朝日新聞社の「認知症フレンドリー講座」と合わせてお申込みいただきますとセット割引で更にお得になります。');
        }
        if(count === 1) {
          switch(people) {
            case 30:
              valueTotal = 150000;
              valueNote = 5000;
              break;
            case 40:
              valueTotal = 160000;
              valueNote = 4000;
              break;
            case 50:
              valueTotal = 175000;
              valueNote = 3500;
              break;
            case 60:
              valueTotal = 210000;
              valueNote = 3500;
              break;
            case 70:
              valueTotal = 245000;
              valueNote = 3500;
              break;
            case 80:
              valueTotal = 280000;
              valueNote = 3500;
              break;
          }
        } else if(count === 12) {
          switch(people) {
            case 30:
              valueTotal = 162000;
              valueNote = 54000;
              break;
            case 40:
              valueTotal = 1728000;
              valueNote = 43200;
              break;
            case 50:
              valueTotal = 1890000;
              valueNote = 37800;
              break;
            case 60:
              valueTotal = 2268000;
              valueNote = 37800;
              break;
            case 70:
              valueTotal = 2646000;
              valueNote = 37800;
              break;
            case 80:
              valueTotal = 3024000;
              valueNote = 37800;
              break;
          }
        } else if(count === 48) {
          switch(people) {
            case 30:
              valueTotal = 5760000;
              valueNote = 192000;
              break;
            case 40:
              valueTotal = 6144000;
              valueNote = 153600;
              break;
            case 50:
              valueTotal = 6720000;
              valueNote = 134400;
              break;
            case 60:
              valueTotal = 8064000;
              valueNote = 134400;
              break;
            case 70:
              valueTotal = 9408000;
              valueNote = 134400;
              break;
            case 80:
              valueTotal = 10752000;
              valueNote = 134400;
              break;
          }
        }
        valueTotal = valueTotal * 1.1;
        valueNote = valueNote * 1.1;
        console.log($('#text-count option:selected').text());
        this.$textType.text($('#workshop-type option:selected').text());
        this.$textPeople.text($('#workshop-people option:selected').text());
        this.$textCount.text($('#workshop-count option:selected').text());
        this.$priceTotal.text(valueTotal.toLocaleString() + '円');
        this.$priceTotalNote.text(valueNote.toLocaleString() + '円');
        this.$overlay.fadeOut(500);
      } else {
        this.$overlay.fadeIn(500);
      }
    });
  }
}

export default Price;
